/**
 * Single source of truth for tutorial / help videos (Item 72).
 *
 * Both the Help & Tutorials hub (the "?" in the top bar) and the in-context
 * embeds (onboarding steps, the IB Flex setup popout) read from here — so to
 * add or change a video you edit ONE place.
 *
 * Videos are hosted on YouTube (unlisted). `youtubeId` is the 11-char id from
 * the share link (youtu.be/<id>). Add a new entry once a clip is recorded; only
 * entries WITH a youtubeId appear in the hub.
 */
export const HELP_VIDEOS = [
  {
    id: 'welcome',
    title: 'Welcome to Kodahfy',
    description: 'A quick intro to how Kodahfy works.',
    youtubeId: '2ll9kAu8voI',
    category: 'Getting started'
  },
  {
    id: 'ib-flex',
    title: 'Connect Interactive Brokers (Flex Query)',
    description: 'Set up automatic syncing from Interactive Brokers.',
    youtubeId: 'J2dtqtV38b4',
    category: 'Getting started'
  }
];

// YouTube serves a thumbnail (your custom one, once processed) at this URL.
export const thumbnailFor = (youtubeId) => `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;

export const getHelpVideo = (id) => HELP_VIDEOS.find((v) => v.id === id) || null;

// Convenience: a youtu.be URL for an id, or '' if not found / not yet recorded.
// Used by the in-context embeds so they share the registry.
export const helpVideoUrl = (id) => {
  const v = getHelpVideo(id);
  return v && v.youtubeId ? `https://youtu.be/${v.youtubeId}` : '';
};

// Categories in first-seen order (for grouping in the hub).
export const helpCategories = () => {
  const cats = [];
  HELP_VIDEOS.forEach((v) => { if (v.youtubeId && !cats.includes(v.category)) cats.push(v.category); });
  return cats;
};
